const COOKIE_KEY = "presto_recent_logins";
const MAX_RECENT = 6;
const EXPIRY_DAYS = 30;

export interface RecentLoginUser {
  name: string;
  email: string;
}

function readCookie(): RecentLoginUser[] {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${COOKIE_KEY}=`));
  if (!match) return [];
  try {
    return JSON.parse(decodeURIComponent(match.split("=").slice(1).join("=")));
  } catch {
    return [];
  }
}

function writeCookie(users: RecentLoginUser[]): void {
  const expires = new Date();
  expires.setDate(expires.getDate() + EXPIRY_DAYS);
  document.cookie = `${COOKIE_KEY}=${encodeURIComponent(
    JSON.stringify(users)
  )}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
}

export function getRecentLogins(): RecentLoginUser[] {
  return readCookie();
}

export function addRecentLogin(firstName: string, lastName: string, email: string): void {
  const name = `${firstName} ${lastName.charAt(0)}.`;
  const existing = readCookie().filter((u) => u.email !== email);
  const updated = [{ name, email }, ...existing].slice(0, MAX_RECENT);
  writeCookie(updated);
}
